import PublicationApi from '~services/publicationApi'
import Socket from '~services/socket'
import PublicationStore from './PublicationStore'

export default new PublicationStore(PublicationApi, Socket)
